import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { PageHeader } from "./analytics-kit";

/*
 * Header for app surfaces reached from the Apps landing (Site Monitor, AI Visibility,
 * Keyword Intelligence, Company Analysis, Market Trends…): the kit PageHeader with an
 * "Apps" breadcrumb. subtitle / chips / actions pass straight through.
 */
const BackToApps = ({
  title,
  subtitle,
  chips,
  actions,
  crumb
}) => /*#__PURE__*/React.createElement(PageHeader, {
  crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: "/Apps"
  }, "Apps"), crumb ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", crumb) : null),
  title: title,
  subtitle: subtitle,
  chips: chips || [],
  actions: actions
});
export default withRouter(BackToApps);